export default {
    dealer_overview_title: 'Distribuidor',
    dealer_overview_actions: 'Acciones',
    dealer_overview_username: 'Nombre de Usuario',
    dealer_overview_opened_at: 'Abierto en',
    dealer_overview_status: 'Estado',
    dealer_overview_package: 'Paquete',
    dealer_overview_devices: 'Dispositivos',
    dealer_overview_brand: 'Marca',
    dealer_overview_crm: 'Id. de Salesforce',
    dealer_overview_activities: 'Actividades',
    dealer_overview_keysfobs: 'Llaves',
    dealer_overview_user: 'Usuarios',
    dealer_overview_edit_dealer: 'Editar Distribuidor',
    dealer_overview_reset_legacy_user: 'Restablecer la Contraseña del Distribuidor',
    dealer_overview_change_dealer_status: 'Cambiar el Estado del Distribuidor',
    dealer_overview_change_dealer_brand: 'Cambiar la Marca del Distribuidor',
    dealer_overview_import_and_assign: 'Importar y Asignar',
    dealer_overview_reset_cognito_user: 'Restablecer la Autenticación de Cognito',
    dealer_overview_device_models: 'Modelos de Dispositivos',
    dealer_overview_part_numbers: 'Números de Pieza',
    dealer_overview_unit_types: 'Tipos de Unidades',
    dealer_overview_active_devices: 'Dispositivos Activos',
    dealer_overview_system_alert_logs: 'Logs Sistema de Alertas',
    dealer_overview_scheduled_reports: 'Reportes Programados',
    dealer_overview_email: 'Correo electrónico',
    dealer_overview_export_logs: 'Registros de Exportación',
    dealer_overview_terms_conditions: 'Verificar los términos y condiciones',
    dealer_overview_scheduled_actions: 'Acciones programadas',
    dealer_overview_change_username: 'Cambiar el Nombre de Usuario',

    dealer_overview_master_company: 'Empresa Maestra',
    dealer_overview_tab_accounts: "Cuentas",
    dealer_overview_tab_packages: "Paquetes",
    dealer_overview_tab_billing_accounts: "Cuentas de Facturación",
    dealer_overview_tab_alert_logs: "Registro de Alertas",
    dealer_overview_tab_webhooks: "WebHooks",
};